import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "aside-nave__brand" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "aside-nave__menu" }
const _hoisted_4 = {
  key: 0,
  class: "aside-nave__menu-items"
}
const _hoisted_5 = { class: "aside-nave__subtitle" }
const _hoisted_6 = {
  key: 0,
  class: "aside-nave__submenu"
}
const _hoisted_7 = ["onClick", "data-test-qa"]
const _hoisted_8 = ["onClick", "data-test-qa"]
const _hoisted_9 = {
  key: 0,
  class: "aside-nave__submenu-item"
}
const _hoisted_10 = {
  key: 0,
  class: "aside-nave__item"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_details_development = _resolveComponent("details-development")!
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("aside", {
    class: _normalizeClass(["aside-nave", { 'collapsed-sidebar': _ctx.toggleSidebar }])
  }, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("img", {
        src: 
          _ctx.toggleSidebar
            ? '/assets/img/logo-icon.svg'
            : '/assets/img/logo-brand.svg'
        ,
        class: _normalizeClass(_ctx.toggleSidebar ? 'logo-icon' : 'logo-brand'),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toHome && _ctx.toHome(...args)))
      }, null, 10, _hoisted_2),
      _createElementVNode("i", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleSidebarClick())),
        class: "icon-nav-arrow_right"
      })
    ]),
    _createElementVNode("article", null, [
      _createVNode(_component_details_development, {
        info: _ctx.infoDetails,
        notice: "warning"
      }, null, 8, ["info"]),
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sidebar, (item, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            (item.title && item.active)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("li", _hoisted_5, _toDisplayString(item.title), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.items, (menu, idx) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: idx }, [
                      (menu.subItems && menu.active)
                        ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
                            (_ctx.toggleSidebar)
                              ? _withDirectives((_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "aside-nave__submenu-list",
                                  onClick: ($event: any) => (_ctx.toggleSubMenu(menu.subItems)),
                                  "data-test-qa": menu.dataTestQa
                                }, [
                                  _createElementVNode("i", {
                                    class: _normalizeClass(["dynamic-icon", menu.icon])
                                  }, null, 2)
                                ], 8, _hoisted_7)), [
                                  [_directive_tooltip, { value: menu.title, class: 'sidebar-tip' }]
                                ])
                              : (_openBlock(), _createElementBlock("div", {
                                  key: 1,
                                  class: "aside-nave__submenu-list",
                                  onClick: ($event: any) => (_ctx.toggleSubMenu(menu.subItems)),
                                  "data-test-qa": menu.dataTestQa
                                }, [
                                  _createElementVNode("i", {
                                    class: _normalizeClass(["dynamic-icon", menu.icon])
                                  }, null, 2),
                                  _createTextVNode(" " + _toDisplayString(menu.title) + " ", 1),
                                  _createElementVNode("i", {
                                    class: _normalizeClass(
                          _ctx.showSubmenuItem === JSON.stringify(menu.subItems)
                            ? 'icon-nav-bullet_up'
                            : 'icon-nav-bullet_down'
                        )
                                  }, null, 2)
                                ], 8, _hoisted_8)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu.subItems, (subitem, indexSubItem) => {
                              return (_openBlock(), _createElementBlock(_Fragment, { key: indexSubItem }, [
                                (
                          _ctx.showSubmenuItem === JSON.stringify(menu.subItems) &&
                          subitem.active
                        )
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                                      _createVNode(_component_router_link, {
                                        onClick: ($event: any) => (_ctx.activeMixPanel(subitem.name)),
                                        to: subitem.href,
                                        "data-test-qa": subitem.dataTestQa
                                      }, {
                                        default: _withCtx(() => [
                                          _cache[2] || (_cache[2] = _createElementVNode("i", { class: "icon-nav-bullet_right" }, null, -1)),
                                          _createElementVNode("span", null, _toDisplayString(subitem.name), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick", "to", "data-test-qa"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (menu.active)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                                  (_ctx.toggleSidebar)
                                    ? _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                                        key: 0,
                                        to: menu.href,
                                        onClick: ($event: any) => (_ctx.activeMixPanel(menu.name))
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("i", {
                                            class: _normalizeClass(menu.icon)
                                          }, null, 2)
                                        ]),
                                        _: 2
                                      }, 1032, ["to", "onClick"])), [
                                        [_directive_tooltip, { value: menu.name, class: 'sidebar-tip' }]
                                      ])
                                    : (_openBlock(), _createBlock(_component_router_link, {
                                        key: 1,
                                        to: menu.href,
                                        onClick: ($event: any) => (_ctx.activeMixPanel(menu.name))
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("i", {
                                            class: _normalizeClass(menu.icon)
                                          }, null, 2),
                                          _createElementVNode("span", null, _toDisplayString(menu.name), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to", "onClick"]))
                                ]))
                              : _createCommentVNode("", true)
                          ], 64))
                    ], 64))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ])
    ])
  ], 2))
}